import { render, staticRenderFns } from "./WorkOrderSideBar.vue?vue&type=template&id=e98ddfb6&"
import script from "./WorkOrderSideBar.vue?vue&type=script&lang=js&"
export * from "./WorkOrderSideBar.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderSideBar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports